<template>
  <div class="base-report report-payment-time">
    <div class="filter">
      <el-form inline>
        <el-select v-model="searchForm.mode" size="mini" >
          <el-option
            v-for="item in modes"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-date-picker
          v-model="searchForm.from_date"
          type="date"
          size="mini"
          placeholder="開始日"
          value-format="yyyy-MM-dd"
          :clearable="false">
        </el-date-picker>
        <el-date-picker
          v-model="searchForm.to_date"
          type="date"
          size="mini"
          placeholder="終了日"
          value-format="yyyy-MM-dd"
          :clearable="false">
        </el-date-picker>
        <el-button size="mini" type="primary" @click="fetchData" :disabled="isLoading">表示</el-button>
        <div style="float: right; padding-right: 20px;">
          <el-button v-show="$store.getters.isPC && screenData.length>0" size="mini" type="success" icon="el-icon-download" @click="exportCSV">ダウンロード</el-button>
        </div>
      </el-form>
    </div>
    <div class="table_data" v-loading="isLoading">
      <template v-if="screenData.length>0">
        <el-table
          :data="screenData"
          border
          stripe
          show-summary
          height="100%"
          :summary-method="getSummaries">
          <template v-for="header in tableSetting">
            <el-table-column
              :key=header.prop
              :label=header.label
              :prop=header.prop
              :formatter="formatter"
              :fixed=header.fixed
              :align=header.align
              :sortable=header.sortable
              :min-width=header.width>
            </el-table-column>
          </template>
        </el-table>
      </template>
      <div v-else v-show="noData">
        データがありません。<br>
        条件を変えて再度「表示」ボタンを押してください。
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import addFigure from '@/misc/addFigure.js'
import utils from '@/misc/utils.js'
import downloadCSV from '@/misc/downloadCSV.js'
import {mapGetters} from 'vuex'

export default {
  name: 'ReportPaymentTime',
  data () {
    const modeType = {
      hourly: 1,
      timezone: 2,
    }
    return {
      rounding: null,
      roundingRatio: null,
      isLoading: false,
      noData: false,
      modeType: {...modeType},
      modes: [{value: modeType.hourly, label: '時間'}, {value: modeType.timezone, label: '時間帯'}],
      tableSetting: [
        {label: '時間', prop: 'hour', align: 'center', fixed: true, sortable: true, width: '130px'},
        {label: '売上（税抜）', prop: 'salesExcludeTax', align: 'right', sortable: true, width: '130px'},
        {label: '組数', prop: 'party', align: 'right', sortable: true, width: '80px'},
        {label: '組単価', prop: 'partySales', align: 'right', sortable: true, width: '100px'},
        {label: '客数', prop: 'person', align: 'right', sortable: true, width: '80px'},
        {label: '客単価', prop: 'personSales', align: 'right', sortable: true, width: '100px'},
        {label: '男性', prop: 'male', align: 'right', sortable: true, width: '80px'},
        {label: '女性', prop: 'female', align: 'right', sortable: true, width: '80px'},
        {label: '滞在時間', prop: 'stay', align: 'right', sortable: true, width: '100px'},
        {label: '回転率', prop: 'turn', align: 'right', sortable: true, width: '110px'},
      ],
      searchForm: {
        mode: modeType.hourly,
        from_date: null,
        to_date: null,
      },
      currentMode: modeType.hourly,
      orgData: [],
      totalData: [],
      timezoneData: {},
      csv_filename: '時間売上.csv',
      numberOfSeat: 0,
      totalStay: 0,
    }
  },
  computed: {
    ...mapGetters('account', [
      'isGroupMode',
    ]),
    ...mapGetters('report', ['roundingFunction', 'roundingRatioFunction']),
    numberOfDays: function () {
      let a = moment(this.searchForm.to_date)
      let b = moment(this.searchForm.from_date)
      return Math.abs(a.diff(b, 'days')) + 1
    },
    isGroupTimezoneMode () {
      return this.isGroupMode && this.currentMode === this.modeType.timezone
    },
    screenData () {
      // update TimeName
      this.tableSetting[0].label = this.getDateStr()

      // update turn & stay
      this.totalStay = this.orgData.reduce((a, b) => a + b.stay, 0)
      for (let data of this.orgData) {
        data.turn = this.roundingRatio(utils.divide(data.person, (this.numberOfSeat * this.numberOfDays)))
        data.stay = utils.divide(data.stay, data.party)
      }

      return this.orgData
    },
  },
  filters: {
    date (value) {
      return moment(value).format('YYYY/MM/DD')
    },
  },
  methods: {
    fetchData () {
      this.isLoading = true
      this.noData = false
      this.items = []
      this.totalData = []
      this.orgData = []
      this.currentMode = this.searchForm.mode
      this.$request.reports.times(this.searchForm.from_date, this.searchForm.to_date, this.currentMode).then(res => {
        this.items = res.body

        if (this.items.data) {
          this.orgData.push(...this.items.data)
        }
        this.numberOfSeat = this.items.seat || 0
      }, err => {
        console.log(err)
      }).finally(() => {
        this.isLoading = false
        this.noData = !this.screenData.length
      })
    },
    getSummaries ({columns, data}) {
      let totalDic = {}
      let seft = this
      columns.forEach((column, index) => {
        if (index === 0) {
          this.totalData[index] = '合計'
          return true
        }
        let prop = columns[index].property
        let reducer = function (a, b) {
          let valb = parseFloat(b[prop]) || 0
          return a + valb
        }
        let values = data.reduce(reducer, 0)
        totalDic[prop] = values

        switch (prop) {
          case 'partySales':
            values = utils.divide(totalDic.salesExcludeTax, totalDic.party)
            break
          case 'personSales':
            values = utils.divide(totalDic.salesExcludeTax, totalDic.person)
            break
          case 'stay':
            values = utils.divide(seft.totalStay, totalDic.party)
            break
          case 'turn':
            values = this.roundingRatio(utils.divide(totalDic.person, (this.numberOfSeat * this.numberOfDays * data.length)))
            break
        }

        this.totalData[index] = this.formatData(prop, values)
      })
      return this.totalData
    },
    exportCSV () {
      let header = []
      let keyList = []
      for (let tableHeader of this.tableSetting) {
        if (Array.isArray(tableHeader)) {
          let preHeader = header.pop()
          for (let subHeader of tableHeader) {
            if (subHeader.prop) {
              keyList.push(subHeader.prop)
            }
            header.push(`${preHeader}-${subHeader.label}`)
          }
        } else {
          if (tableHeader.prop) {
            keyList.push(tableHeader.prop)
          }
          header.push(tableHeader.label)
        }
      }
      let data = []
      for (let record of this.screenData) {
        let tmp = []
        for (let key of keyList) {
          tmp.push(this.formatData(key, record[key]))
        }
        data.push(tmp)
      }

      downloadCSV(this.csv_filename, header, data, this.totalData)
    },
    date (value) {
      let result = '-'
      switch (this.currentMode) {
        case this.modeType.hourly:
          result = value + ':00〜' + value + ':59'
          break
        case this.modeType.timezone:
          if (typeof (value) === 'number') {
            result = value + ':00〜' + value + ':59'
          } else {
            result = value
          }
          break
      }
      return result
    },
    getDateStr () {
      let seft = this
      let rs = this.modes.filter((modes) => modes.value === seft.currentMode)[0].label
      return rs
    },
    formatter (row, column) {
      let key = column.property
      return this.formatData(key, row[key])
    },
    formatData (key, value) {
      switch (key) {
        case 'hour':
          return this.date(value)
        case 'stay':
          return utils.formatStay(value)
        case 'turn':
          return parseFloat(value).toFixed(2)
        default:
          return addFigure(this.rounding(value))
      }
    },
  },
  created () {
    this.rounding = this.roundingFunction
    this.roundingRatio = this.roundingRatioFunction
  },
  mounted () {
    this.searchForm.from_date = moment().date(1).format('YYYY-MM-DD')
    this.searchForm.to_date = moment().format('YYYY-MM-DD')
  },
}
</script>

<style lang="sass">
@import "static/sass/report/common.sass"
</style>



// WEBPACK FOOTER //
// src/components/Report/PaymentTime.vue